/**
 * Navegar sin cambiar de tienda sin querer.
 *
 * Por el contenido hay enlaces escritos con el dominio entero
 * (https://tiendamanilla.com/pages/…): en las tiendas de Francia, Portugal y
 * Alemania, pulsarlos te sacaba al escaparate español, con su idioma y sus
 * precios, en mitad de la navegación.
 *
 * Aquí se reescriben esos enlaces al dominio en el que ya estás, conservando
 * ruta, parámetros y ancla. Escribir la dirección a mano en el navegador sigue
 * llevando donde diga: esto solo toca los enlaces de dentro de la web.
 *
 * Lo que NO se toca:
 *   - El selector de idioma/país, que es un <form> a /localization.
 *   - Las etiquetas <link> (canonical y hreflang): son señales para Google y
 *     deben seguir apuntando a donde apuntan.
 *   - Otros subdominios (orders.tiendamanilla.com…) y cualquier dominio ajeno.
 */
(function () {
  'use strict';

  var PRINCIPALES = ['tiendamanilla.com', 'www.tiendamanilla.com'];

  // En el escaparate español no hay nada que corregir.
  if (PRINCIPALES.indexOf(window.location.hostname) !== -1) return;

  var MARCA = 'data-tm-mercado';

  function corregir(a) {
    if (!a || a.hasAttribute(MARCA)) return;
    a.setAttribute(MARCA, '');

    var href = a.getAttribute('href');
    if (!href) return;
    // Anclas, mailto:, tel:, javascript:… no llevan a ninguna tienda.
    if (href.charAt(0) === '#' || href.indexOf(':') !== -1 && !/^https?:/i.test(href)) return;

    var url;
    try { url = new URL(a.href, window.location.href); } catch (e) { return; }
    if (PRINCIPALES.indexOf(url.hostname) === -1) return;

    url.hostname = window.location.hostname;
    a.href = url.toString();
  }

  function barrer(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    var enlaces = raiz.querySelectorAll('a[href]:not([' + MARCA + '])');
    for (var i = 0; i < enlaces.length; i++) corregir(enlaces[i]);
  }

  function arrancar() {
    barrer(document);

    // Filtros, mini-carrito, vista rápida… traen enlaces nuevos por AJAX.
    if (!window.MutationObserver) return;
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        barrer(document);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // Red de seguridad: un enlace recién creado y pulsado antes de que el
  // observador haya pasado. Se corrige el href justo antes de navegar.
  ['click', 'auxclick'].forEach(function (evento) {
    document.addEventListener(evento, function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      a.removeAttribute(MARCA);
      corregir(a);
    }, true);
  });
})();
